<template>
  <div class="ad-container">
    <div class="ad" :style="{width: width,height: height}" @click="clickAd">
      <img v-if="content.image" :src="content.image" /> 
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    }, 
    height: {
      type: String,
      required: true
    },
    content: {
      type: Object,
      required: true
    }
  },
  methods: {
    clickAd() {
      if(!this.content.link) return
      window.location.href = this.content.link
    }
  },
}
</script>

<style lang="stylus" scoped>
.ad-container
  width 100%
  background #ffffff
  .ad
    margin 0 auto
    img
      width 100%
      height 100%
</style>